import { render, staticRenderFns } from "./SupportedImportDetails.vue?vue&type=template&id=051bf002"
import script from "./SupportedImportDetails.vue?vue&type=script&lang=js"
export * from "./SupportedImportDetails.vue?vue&type=script&lang=js"
import style0 from "./SupportedImportDetails.vue?vue&type=style&index=0&id=051bf002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports